<script>
    import {link} from "svelte-spa-router"
    import Carousel from "svelte-carousel";
    import {onDestroy, onMount} from "svelte";
    import {API_URL} from "../../env";

    let particlesToShow = 4;
    let particlesToScroll = 4;

    let resizeObserver;

    let reviews = [];
    let total = 0;
    let totalScore = 0;

    async function fetchReviews() {
        const response = await fetch(API_URL + '/reviews');
        reviews = await response.json();

        total = reviews.total;
        totalScore = reviews.totalScore.toFixed(1);

        reviews.reviews.forEach(review => {
            const date = new Date(review.timestamp * 1000);
            const now = new Date();
            const diff = Math.floor((now - date) / 1000);
            let time = '';
            if (diff < 60) {
                time = 'pred 1 minútou';
            } else if (diff < 3600) {
                time = `pred ${Math.floor(diff / 60)} minútami`;
            } else if (diff < 86400) {
                if(Math.floor(diff / 3600) === 1) time = `pred hodinou`;
                else time = `pred ${Math.floor(diff / 3600)} hodinami`;
            } else if (diff < 604800) {
                if(Math.floor(diff / 86400) === 1) time = `pred dňom`;
                else time = `pred ${Math.floor(diff / 86400)} dňami`;
            } else if (diff < 2629743) {
                if(Math.floor(diff / 604800) === 1) time = `pred týždňom`;
                else time = `pred ${Math.floor(diff / 604800)} týždňami`;
            } else if (diff < 31556926) {
                if(Math.floor(diff / 2629743) === 1) time = `pred mesiacom`;
                else time = `pred ${Math.floor(diff / 2629743)} mesiacmi`;
            } else {
                if(Math.floor(diff / 31556926) === 1) time = `pred rokom`;
                else time = `pred ${Math.floor(diff / 31556926)} rokmi`;
            }
            review.time = time;
        });
    }

    onMount(() => {
        fetchReviews();

        resizeObserver = new ResizeObserver(entries => {
            for (let entry of entries) {
                if (entry.contentRect.width < 768) {
                    particlesToShow = 1;
                    particlesToScroll = 1;
                } else if (entry.contentRect.width < 1200) {
                    particlesToShow = 2;
                    particlesToScroll = 2;
                } else if (entry.contentRect.width < 1800) {
                    particlesToShow = 3;
                    particlesToScroll = 3;
                } else {
                    particlesToShow = 4;
                    particlesToScroll = 4;
                }
            }
        });

        resizeObserver.observe(document.body);
    });

    onDestroy(() => {
        if (resizeObserver) {
            resizeObserver.disconnect();
        }
    });
</script>

<section class="heureka">
    <div class="container">
        <div class="row">
            <div class="col-lg-3 mb-4 mb-lg-0">
                <div class="heureka-content">
                    <a href="https://obchody.heureka.sk/pneuin-sk/recenze/" target="_blank" rel="noopener">
                        <img src="/assets/img/heureka-logo.svg" alt="Heureka.sk">
                    </a>
                    <p>Hodnotenie obchodu <b>{totalScore} / 5</b></p>
                    <div class="rating-stars">
                        <div class="back-stars">
                            <i class="fas fa-fw fa-star"></i>
                            <i class="fas fa-fw fa-star"></i>
                            <i class="fas fa-fw fa-star"></i>
                            <i class="fas fa-fw fa-star"></i>
                            <i class="fas fa-fw fa-star"></i>
                            <div class="front-stars" style="width: {(totalScore / 5) * 100}%;">
                                <i class="fas fa-fw fa-star"></i>
                                <i class="fas fa-fw fa-star"></i>
                                <i class="fas fa-fw fa-star"></i>
                                <i class="fas fa-fw fa-star"></i>
                                <i class="fas fa-fw fa-star"></i>
                            </div>
                        </div>
                    </div>
                    <p class="mb-0">Na základe<br><a href="https://obchody.heureka.sk/pneuin-sk/recenze/" target="_blank" rel="noopener">{total} overených recenzií</a></p>
                </div>
            </div>
            <div class="col-lg-9">
                {#if reviews && reviews.reviews && reviews.reviews.length > 0}
                    <Carousel
                            {particlesToShow}
                            {particlesToScroll}
                            swiping={true}
                            dots={false}
                            infinite={false}
                            gapSize={20}
                            let:showPrevPage
                            let:showNextPage
                    >

                        {#each reviews.reviews as review (review)}
                            <div class="rating-item">
                                <div class="rating-stars">
                                    <div class="back-stars">
                                        <i class="fas fa-fw fa-star"></i>
                                        <i class="fas fa-fw fa-star"></i>
                                        <i class="fas fa-fw fa-star"></i>
                                        <i class="fas fa-fw fa-star"></i>
                                        <i class="fas fa-fw fa-star"></i>
                                        <div class="front-stars" style="width: {(review.rating/5)*100}%;">
                                            <i class="fas fa-fw fa-star"></i>
                                            <i class="fas fa-fw fa-star"></i>
                                            <i class="fas fa-fw fa-star"></i>
                                            <i class="fas fa-fw fa-star"></i>
                                            <i class="fas fa-fw fa-star"></i>
                                        </div>
                                    </div>
                                </div>
                                <span>{review?.time}</span>
                                <p>{review?.text}</p>
                                <b>{review?.name.replaceAll(' ', '')} {review?.surname}.</b>
                            </div>
                        {/each}

                        <button type="button" slot="prev" on:click={showPrevPage} class="custom-arrow custom-arrow-prev">
                            <i class="far fa-fw fa-chevron-left"></i>
                        </button>
                        <button type="button" slot="next" on:click={showNextPage} class="custom-arrow custom-arrow-next">
                            <i class="far fa-fw fa-chevron-right"></i>
                        </button>
                    </Carousel>
                {/if}
            </div>
        </div>
    </div>
</section>

<footer>
    <div class="container">
        <div class="row">
            <div class="col-lg-4 col-xl-4 d-flex align-items-center">
                <div class="footer-address">
                    <ul>
                        <li><i class="fas fa-map-marked-alt"></i> Valaliky, <!--Kostolná 117/18, -->044 13</li>
                        <li><i class="fas fa-clock"></i> Pon-Pia: 8:00 - 16:00</li>
                        <li><i class="fas fa-phone-alt"></i> <a href="tel:+421911022525">+421 911 022 525</a></li>
                        <li><i class="fas fa-envelope"></i> <a href="mailto:info@pneuin.sk">info@pneuin.sk</a></li>
                    </ul>
                </div>
            </div>
            <div class="col-lg-5 col-xl-4">
                <div class="footer-fast">
                    <span>Rychlé odkazy</span>
                    <ul>
                        <li><a use:link href="/doprava-a-dodanie">Doprava a doba dodania</a></li>
                        <li><a use:link href="/obchodne-podmienky">Obchodné podmienky</a></li>
                        <li><a use:link href="/reklamacny-poriadok">Reklamačný poriadok</a></li>
                        <li><a use:link href="/ochrana-osobnych-udajov">Ochrana osobných údajov</a></li>
                        <li><a use:link href="/kontakt">Kontakt</a></li>
                        <li id="cookie-consent-btn"><p>Nastavenie cookies</p></li>
                    </ul>
                </div>
            </div>
            <div class="col-lg-3 mt-lg-auto col-xl-4">
                <div class="footer-copyright">
                    <p>Vytvoril <a href="https://neoloop.cz/" target="_blank" rel="noopener" class="mx-1"><img src="https://cdn.neoloop.cz/images/logo-whitewhite.svg" height="20px;" alt="Neoloop"></a> &copy; {new Date().getFullYear()}</p>
                    <p>Všetky práva vyhradené</p>
                </div>
            </div>
        </div>
    </div>
</footer>

<style>
    .heureka {
        margin-top: 4rem;
        background-color: #fdf6f0;
        padding: 2.5rem 0;
    }
    .heureka .heureka-content {
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .heureka .heureka-content img {
        height: 2rem;
    }
    .heureka .heureka-content p {
        margin: .75rem 0;
        text-align: center;
    }
    .heureka .heureka-content p a {
        text-decoration: underline;
        color: #0096ff;
        transition: .1s linear
    }
    .heureka .heureka-content p a:hover {
        color: #ff660a;
    }
    .heureka .rating-stars {
        display: flex;
        justify-content: center;
        align-items: center;
        margin: .5rem 0;
        font-size: 1.15rem;
    }
    .heureka .rating-stars .back-stars {
        display: flex;
        position: relative;
        gap: .25rem;
        color: #d2d2d2;
    }
    .heureka .rating-stars .front-stars {
        position: absolute;
        display: inline-block;
        flex-wrap: nowrap;
        white-space: nowrap;
        overflow: hidden;
        color: #ff660a;
        top: -.1rem;
        left: 0;
    }
    :global(.heureka .custom-arrow) {
        position: absolute;
        background-color: white;
        color: black;
        border-radius: 50%;
        height: 2.5rem;
        width: 2.5rem;
        display: flex;
        justify-content: center;
        align-items: center;
        transition: .15s linear;
        cursor: pointer;
        z-index: 150;
        box-shadow: 0 4px 6px rgba(64, 65, 66, .1);
        top: 40%;
        font-size: 1.1rem;
    }
    :global(.heureka .custom-arrow.custom-arrow-prev) {
        left: -1.5rem;
    }
    :global(.heureka .custom-arrow.custom-arrow-next) {
        right: -1.5rem;
    }
    :global(.heureka .custom-arrow.custom-arrow-prev:hover) {
        transform: scale(1.2);
    }
    :global(.heureka .custom-arrow.custom-arrow-next:hover) {
        transform: scale(1.2);
    }
    @media (max-width: 991.98px) {
        :global(.heureka .custom-arrow) {
            display: none;
        }
    }
    .heureka .rating-item {
        background-color: white;
        border-top: 3px solid #0096ff;
        border-radius: .25rem;
        padding: 1.5rem;
        font-size: .9rem;
        position: relative;
        display: flex;
        flex-direction: column;
        height: 100%;
    }
    .heureka .rating-item .rating-stars {
        justify-content: start;
        margin-top: 0;
        font-size: 1rem;
    }
    .heureka .rating-item span {
        position: absolute;
        top: 1.5rem;
        right: 1.5rem;
        color: #999897;
    }
    .heureka .rating-item p {
        color: #141414;
        margin: .5rem 0 1rem 0;
        height: 3.25rem;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
    }
    .heureka .rating-item b {
        color: #141414;
        font-weight: 700;
    }

    footer {
        padding: 2.5rem 0;
        background-image: linear-gradient(264.86deg, rgba(15, 23, 42, 0.5) 0%, rgba(15, 23, 42, 0.95) 100%), url("/assets/img/footer.webp");
        background-repeat: no-repeat;
        background-position: right;
        background-size: cover;
    }
    .footer-address {
        background-color: rgba(255, 255, 255, .05);
        color: white;
        padding: 0.8rem 1rem;
        border-radius: 1.5rem;
        width: 100%;
    }
    .footer-address ul {
        list-style-type: none;
        padding-left: 0;
    }
    .footer-address ul li i {
        font-size: 1.5rem;
        padding: 0.8rem;
    }
    .footer-address ul li a {
        color: white;
    }
    .footer-address ul li a:hover {
        color: #ff660a;
    }
    .footer-fast {
        padding-left: 2rem;
        margin: 2rem 0;
        color: white;
    }
    .footer-fast span {
        font-family: Rubik, sans-serif;
        font-weight: 600;
        border-bottom: 2px solid rgba(255, 255, 255, 0.5);
        font-size: 1.25rem;
        padding-bottom: .25rem;
        margin-bottom: 1rem;
        display: block;
        width: fit-content;
    }
    .footer-fast ul {
        list-style-type: none;
        padding: 0;
        column-count: 2;
    }
    .footer-fast ul li {
        padding: 0.6rem 0;
        width: fit-content;
        transition: .1s linear;
    }
    .footer-fast ul li,
    .footer-fast ul li a {
        color: white;
    }
    .footer-fast ul li:hover,
    .footer-fast ul a:hover {
        color: #ff660a;
    }
    .footer-fast ul li a,
    .footer-fast ul li p {
        cursor: pointer;
    }
    .footer-copyright {
        display: flex;
        flex-direction: column;
        justify-content: right;
        place-items: end;
        color: white;
    }
    .footer-copyright p img {
        margin-bottom: -6px;
    }
    @media (max-width: 991.98px) {
        footer {
            background: rgba(15, 23, 42, 0.95);
        }
        .footer-fast {
            padding-left: 0;
        }
        .footer-copyright {
            display: flex;
            flex-direction: column;
            place-items: center;
            gap: .5rem;
        }
    }
    @media (max-width: 575.98px) {
        .footer-fast ul {
            column-count: 1;
        }
    }
</style>